export default __webpack_public_path__ + "images/caf2eb90a34efd09b8d585109889bf83-wrestling.webp";